// extracted by mini-css-extract-plugin
export default {"swiper-slide-active":"styles_swiper-slide-active__J0Q-d","title":"styles_title__G39PF"};